var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.143,
    height: 9.714,
    viewBox: "0 0 12.143 9.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5718",
    "data-name": "Group 5718",
    transform: "translate(4706 2843.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4670",
    "data-name": "Path 4670",
    d: "M70.016,414.37h1.923v1.943H70.016Z",
    transform: "translate(-4776.016 -3249.65)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4671",
    "data-name": "Path 4671",
    d: "M222.14,414.37h8.844v1.943H222.14Z",
    transform: "translate(-4924.841 -3249.65)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4672",
    "data-name": "Path 4672",
    d: "M70.016,235.21h1.923v1.943H70.016Z",
    transform: "translate(-4776.016 -3074.375)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4673",
    "data-name": "Path 4673",
    d: "M222.14,235.21h8.844v1.943H222.14Z",
    transform: "translate(-4924.841 -3074.375)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4674",
    "data-name": "Path 4674",
    d: "M70.016,56.012h1.923v1.943H70.016Z",
    transform: "translate(-4776.016 -2899.063)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4675",
    "data-name": "Path 4675",
    d: "M222.14,56.012h8.844v1.943H222.14Z",
    transform: "translate(-4924.841 -2899.063)",
    fill: "#091b49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.3cffb59e62b1b88a19e4d8414676f365.svg";
export { ForwardRef as ReactComponent };